import { type IInputWidget } from '../../../widgets/repository/inputs/IInputWidget.ts';
import { type Datatype } from '../../datatype/Datatype.ts';
import { type IReference, ReferenceType } from '../IReference.ts';
import { type IReferencePath } from '../IReferencePath.ts';

export function getSimpleWidgetReference(
  type:
    | Datatype.Boolean
    | Datatype.Number
    | Datatype.Date
    | Datatype.String
    | Datatype.File
    | Datatype.Empty
    | Datatype.Hidden,
) {
  return (path: IReferencePath, widget: IInputWidget): IReference => {
    return {
      type: ReferenceType.Widget,
      widgetType: widget.type,
      path,
      id: widget.id,
      code: widget.code,
      label: widget.code,
      field: {
        type,
      },
    };
  };
}
